var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar-item',{attrs:{"link":{
      name: _vm.$t('sidebar.dashboard'),
      icon: 'tim-icons icon-chart-pie-36',
      path: {name: 'manager.dashboard'}
    }}}),_c('sidebar-item',{attrs:{"link":{
      name: _vm.$t('sidebar.control_tower'),
      icon: 'tim-icons icon-chart-bar-32',
      path: {name: 'manager.marine_control_tower'}
    }}},[_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.kanban'),
        path: {name: 'manager.control_tower'},
        isRoute: false,
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.map'),
        path: {name: 'manager.order_in_progress'},
        isRoute: false,
      }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.requests'),
          icon: 'tim-icons icon-basket-simple',
        }}},[(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"material":true,"link":{
        name: _vm.$t('sidebar.request_files'),
        icon: 'playlist_add_check',
        path: {name: 'manager.request_files'},
        isRoute: false,
      }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"material":true,"link":{
        name: _vm.$t('sidebar.request'),
        icon: 'playlist_add_check',
        path: {name: 'manager.request'},
        isRoute: false,
      }}}):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"material":true,"link":{
        name: _vm.$t('sidebar.road_map'),
        icon: 'map',
        path: {name: 'manager.road_map'},
        isRoute: false,
      }}}):_vm._e(),_c('sidebar-item',{attrs:{"material":true,"link":{
        name: _vm.$t('sidebar.box'),
        icon: 'map',
        path: {name: 'manager.box'},
        isRoute: false,
      }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.shippings'),
          icon: 'tim-icons icon-coins',
        }}},[_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.simulation'),
        path: {name: 'manager.order_simulation'},
        isRoute: false,
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: this.$t('sidebar.quotes'),
        path: {name: 'manager.order_quotes'},
        isRoute: false,
      }}})],1),_c('sidebar-item',{attrs:{"material":true,"link":{
    name: 'Importação Maritima',
    icon: 'anchor',
    }}},[_c('sidebar-item',{attrs:{"link":{
          name: 'Farol de Navios',
          path: {name: 'manager.marine_dashboard'}
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Cargas Maritimas',
          path: {name: 'manager.marine'}
        }}})],1),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.orders'),
          icon: 'tim-icons icon-delivery-fast',
        }}},[_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.all_orders'),
          path: {name: 'manager.order'}

        }}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.occurrences'),
        path: {name: 'manager.order_occurrences'},
        isRoute: false,
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('pages.fob_order.title'),
        path: {name: 'manager.fob_order'},
        isRoute: false
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.list_documents'),
        path: {name: 'manager.orders_documents'},
        isRoute: false,
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('placeholders.exports'),
        path: {name: 'manager.orders_exports'},
        isRoute: false,
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.import_cte'),
        path: {name: 'manager.import_cte'},

        }}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.not_imported_files'),
        path: {name: 'manager.not_imported_files'},

        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.canceled'),
          path: {name: 'manager.order_canceled'}
        }}}),_c('sidebar-item',{attrs:{"material":true,"link":{
          name: _vm.$t('sidebar.address'),
          icon: 'list',
          path: {name: 'manager.address_alias'}
        }}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.vehicles'),
        icon: 'tim-icons icon-bus-front-12',
        path: {name: 'manager.vehicle'}
      }}})],1),_c('sidebar-item',{attrs:{"material":true,"link":{
    name: 'Gerenciamento de Patio',
    icon: 'warehouse',
    }}},[_c('sidebar-item',{attrs:{"link":{
          name: 'Controle de Patio',
          path: {name: 'manager.container_control_tower'}
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Lista de Containers',
          path: {name: 'manager.containers'}
        }}})],1),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value])
          && _vm.$hasRole(_vm.role.MANAGER.value))?_c('sidebar-item',{attrs:{"link":{
      name: _vm.$t('sidebar.purchase_order'),
      icon: 'tim-icons icon-cart'
    }}},[_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.charts'),
          path: {name: 'manager.purchase_order_board'}
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.purchase_order'),
          icon: 'tim-icons icon-cart',
          path: {name: 'manager.purchase_order'}

        }}})],1):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value, _vm.permission.BILLING__OWNER.value]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.faturas'),
          icon: 'tim-icons icon-money-coins',
        }}},[_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.current_billing'),
          icon: 'tim-icons icon-shape-star',
          path: {name: 'manager.billing.opened'}
    }}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.billing'),
        icon: 'tim-icons icon-money-coins',
        path: {name: 'manager.billing'}
      }}})],1):_vm._e(),(_vm.$canAny([
      _vm.permission.INTEGRA_MANAGER__OWNER.value,
      _vm.permission.INTEGRA_MANAGER__ADMIN.value,
      _vm.permission.INTEGRA_MANAGER__FINANCIER.value,
      _vm.permission.INTEGRA_MANAGER__FINANCIER_BASIC.value
    ]))?_c('sidebar-item',{attrs:{"material":true,"link":{
          name: _vm.$t('sidebar.reports'),
          icon: 'list',
        }}},[(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.list_documents'),
        path: {name: 'manager.orders_documents'},
        isRoute: false,
      }}}):_vm._e(),(_vm.$canAny([
        _vm.permission.INTEGRA_MANAGER__OWNER.value,
        _vm.permission.INTEGRA_MANAGER__ADMIN.value
      ]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.orders'),
          icon: 'tim-icons icon-notes',
          path:{name: 'manager.order_export'},
        }}}):_vm._e(),(_vm.$canAny([
        _vm.permission.INTEGRA_MANAGER__OWNER.value,
        _vm.permission.INTEGRA_MANAGER__ADMIN.value
      ]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.requests'),
          path:{name: 'manager.request_export'},
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.canhoto_check'),
        icon: 'assignment_turned_in',
        path: {name: 'manager.canhoto'}
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.nf_files'),
        icon: 'assignment_turned_in',
        path: {name: 'manager.nf_files'}
      }}})],1):_vm._e(),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.exports_imports'),
          icon: 'tim-icons icon-notes',
        }}},[_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.list_documents'),
        icon: 'tim-icons icon-notes',
        path:{name: 'manager.orders_documents_export'},
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.orders'),
        icon: 'tim-icons icon-notes',
        path:{name: 'manager.order_reports'},
      }}}),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.requests'),
        path:{name: 'manager.request_reports'},
      }}}),(_vm.$canAny([
      _vm.permission.INTEGRA_MANAGER__OWNER.value,
      _vm.permission.INTEGRA_MANAGER__ADMIN.value
    ]))?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.transporters'),
        icon: 'tim-icons icon-notes',
        path:{name: 'manager.transporters_export'},
      }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('sidebar.import_cte'),
        path: {name: 'manager.import_cte'},

    }}})],1):_vm._e(),_c('sidebar-item',{attrs:{"material":true,"link":{
      name: _vm.$t('sidebar.users_and_companies'),
      icon: 'group',
    }}},[_c('sidebar-item',{attrs:{"material":true,"link":{
          name: _vm.$t('sidebar.users'),
          path: {name: 'manager.user'},
          isRoute: false
        }}}),_c('sidebar-item',{attrs:{"link":{
           name: _vm.$t('sidebar.shippers'),
           path: {name: 'manager.shipper'},
           isRoute: false,
         }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.transporters'),
              path: {name: 'manager.transporter'},
              isRoute: false,
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.risk_managers'),
              path: {name: 'manager.risk_manager'},
              isRoute: false,
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.brokers'),
              path: {name: 'manager.broker'},
              isRoute: false,
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.customers'),
              path: {name: 'manager.customer'},
              isRoute: false,
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.logistics_managers'),
              path: {name: 'manager.four_pl'},
              isRoute: false,
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.finance_managers'),
              path: {name: 'manager.finance_manager'},
              isRoute: false,
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.auditors'),
              path: {name: 'manager.auditor'},
              isRoute: false,
            }}}),_c('sidebar-item',{attrs:{"link":{
              name: _vm.$t('sidebar.drivers'),
              icon: 'tim-icons icon-single-02',
              path: {name: 'manager.driver'}
            }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.suppliers'),
          path: {name: 'manager.supplier'},
          isRoute: false
        }}})],1),(_vm.$canAny([_vm.permission.INTEGRA_MANAGER__OWNER.value, _vm.permission.INTEGRA_MANAGER__ADMIN.value]))?_c('sidebar-item',{attrs:{"material":true,"link":{
          name: _vm.$t('sidebar.settings'),
          icon: 'settings',
          path: {name: 'manager.configuration'}
        }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }